export const LoginIcon = ({
  height = "24px",
  width = "24px",
  fillColor = "#000",
}) => {
  return (
<svg xmlns="http://www.w3.org/2000/svg" fill={fillColor} viewBox="0 0 24 24" id="Login-2--Streamline-Sharp" height={height} width={width} ><desc>{"Login 2 Streamline Icon: https://streamlinehq.com"}</desc><g id="login-2--arrow-enter-left-login-point-circle"><path id="Union" fill={fillColor} fillRule="evenodd" d="M13.0002 9H13v1.5h10v3H13V15h0.0002v1H12l-4 -4 4 -4h1.0002v1Zm1.5 0V6.5h-3.1213L5.87891 12l5.49999 5.5h3.1213V15h6.042c-1.2743 4.0571 -5.0646 7 -9.5422 7 -5.52285 0 -10 -4.4772 -10 -10C1 6.47715 5.47715 2 11 2c4.4776 0 8.2679 2.94289 9.5422 7h-6.042Z" clipRule="evenodd" strokeWidth={1} /></g></svg>
  );
};
